import Vue from 'vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import router from './router';
import store from './store';
import App from './App.vue';
import './style/common.scss';
import { has } from './config/auth';
import './utils/directives';
import { baseExportUrl, baseUrl, switchUnite } from '@/config/env';
import { Loading } from 'element-ui';
// 打印
import Print from 'vue-print-nb';

Vue.use(Print);

// 高德地图
import VueAMap from 'vue-amap';
//引入高德地图
Vue.use(VueAMap);
VueAMap.initAMapApiLoader({
  'key': 'bb9843016802c79d52cff58429bb1c77',
  'plugin': ['AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PlaceSearch', 'AMap.Geolocation', 'AMap.Geocoder'],
  'v': '1.4.4',
  'uiVersion': '1.0'
});


import axios from 'axios';

Vue.prototype.$axios = axios;

//注册全局过滤器
import vueFilter from '@/filter';

for (let key in vueFilter) {
  Vue.filter(key, vueFilter[key]);
}

// 引入阿里图标
import './assets/icons/iconfont.css';
import { getSessionStore } from '@/config/mUtils';

Vue.config.productionTip = false;

Vue.use(ElementUI);

new Vue({
  router,
  store,
  has,
  'render': h => h(App)
}).$mount('#app');


window.exportExcel = function(url, exportParams, exportName, func) {
  const loading = Loading.service({
    'lock': true,
    'text': 'Loading',
    'spinner': 'el-icon-loading',
    'background': 'rgba(0, 0, 0, 0.7)'
  });
  // let blob = new Blob([data], {
  //         'type': 'application/vnd.ms-excel'
  //     }),
  //     resUrl = URL.createObjectURL(blob),
  //     link = document.createElement('a');
  //
  // link.style.display = 'none';
  // link.href = resUrl;
  // link.setAttribute('download', name);
  // document.body.appendChild(link);
  // link.click();
  // document.body.removeChild(link);
  let token = getSessionStore('token');

  let urli = '';

  if(switchUnite) {
    urli = url;
  } else {
    urli = url.replace(baseUrl+'/platform', baseExportUrl + '/exportOrDown');
  }

  fetch(urli, {
    'method': 'POST',
    'body': JSON.stringify(exportParams), // 这里放请求数据
    'headers': {
      'Content-Type': 'application/json',
      'Authorization': token
    },
    'timeout': 50 * 60 * 1000
  })
    .then((res) => {
      if(func) {
        func();
      }
      return res.blob();
    })
    .then(response => {
      const blob = new Blob([response], { 'type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }), // 导出.xlsx结尾的文件
        a = document.createElement('a');

      a.href = window.URL.createObjectURL(blob);
      a.download = exportName + '.xls';
      a.click();
      loading.close();
    });
};

/**兼容旧版 请勿使用 - 新增导出请使用  */
window.exportExcelGet = function(url, objStr) {

  const loading = Loading.service({
    'lock': true,
    'text': 'Loading',
    'spinner': 'el-icon-loading',
    'background': 'rgba(0, 0, 0, 0.7)'
  });

  if (switchUnite) {
    window.location.href = `${baseExportUrl}${url}?access_token=${getSessionStore('token')}&${objStr}`;
  } else {
    window.location.href = `${baseExportUrl}${url.replace('/platform', '/exportOrDown')}?access_token=${getSessionStore('token')}&${objStr}`;
  }
  loading.close();
};

/**兼容旧版 请勿使用 - 新增导出请使用  */
window.exportExcelGetNew = function(url, obj) {
  const loading = Loading.service({
    'lock': true,
    'text': 'Loading',
    'spinner': 'el-icon-loading',
    'background': 'rgba(0, 0, 0, 0.7)'
  });
  let objStr = '';
  const objKeyArr = Object.keys(obj);

  objKeyArr.forEach((key, i) => {
    objStr = objStr + `${key}=${obj[key]}`;
    if (i < objKeyArr.length - 1) {
      objStr = objStr + '&';
    }
  });

  if(switchUnite) {
    window.location.href = `${baseExportUrl}${url}?access_token=${getSessionStore('token')}&${objStr}`;
  } else {
    window.location.href = `${baseExportUrl}${url.replace('/platform', '/exportOrDown')}?access_token=${getSessionStore('token')}&${objStr}`;
  }
  loading.close();

};

/**新版导出通用方法 */
window.exportExcelAll = function(type, url, obj, name) {
  const loading = Loading.service({
    'lock': true,
    'text': 'Loading',
    'spinner': 'el-icon-loading',
    'background': 'rgba(0, 0, 0, 0.7)'
  });
  let token = getSessionStore('token');
  let urli = '';

  if (switchUnite) {
    urli = baseUrl + '/platform' + url + `?access_token=${token}`;
  } else {
    urli = baseUrl + '/exportOrDown' + url + `?access_token=${token}`;
  }

  if(type === 'post') {
    fetch(urli, {
      'method': 'POST',
      'body': JSON.stringify(obj), // 这里放请求数据
      'headers': {
        'Content-Type': 'application/json',
        'Authorization': token
      },
      'timeout': 50 * 60 * 1000
    })
      .then((res) => {
        return res.blob();
      })
      .then(response => {
        const blob = new Blob([response], { 'type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }), // 导出.xlsx结尾的文件
          a = document.createElement('a');

        a.href = window.URL.createObjectURL(blob);
        a.download = name + '.xls';
        a.click();
        loading.close();
      });
  } else if(type === 'get') {
    let objStr = '';
    const objKeyArr = Object.keys(obj);

    objKeyArr.forEach((key, i) => {
      objStr = objStr + `${key}=${obj[key]}`;
      if (i < objKeyArr.length - 1) {
        objStr = objStr + '&';
      }
    });

    window.location.href = `${urli}&${objStr}`;
    loading.close();
  }

};

window.exportExcelAllFunc = function({type, url, obj, name, func}) {
  const loading = Loading.service({
    'lock': true,
    'text': 'Loading',
    'spinner': 'el-icon-loading',
    'background': 'rgba(0, 0, 0, 0.7)'
  });
  let token = getSessionStore('token');
  let urli = '';

  if (switchUnite) {
    urli = baseUrl + '/platform' + url + `?access_token=${token}`;
  } else {
    urli = baseUrl + '/exportOrDown' + url + `?access_token=${token}`;
  }

  if(type === 'post') {
    fetch(urli, {
      'method': 'POST',
      'body': JSON.stringify(obj), // 这里放请求数据
      'headers': {
        'Content-Type': 'application/json',
        'Authorization': token
      },
      'timeout': 50 * 60 * 1000
    })
      .then((res) => {
        return res.blob();
      })
      .then(response => {
        const blob = new Blob([response], { 'type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }), // 导出.xlsx结尾的文件
          a = document.createElement('a');

        a.href = window.URL.createObjectURL(blob);
        a.download = name + '.xls';
        a.click();
        loading.close();
        if (func) {
          func();
        }
      });
  } else if(type === 'get') {
    let objStr = '';
    const objKeyArr = Object.keys(obj);

    objKeyArr.forEach((key, i) => {
      objStr = objStr + `${key}=${obj[key]}`;
      if (i < objKeyArr.length - 1) {
        objStr = objStr + '&';
      }
    });

    window.location.href = `${urli}&${objStr}`;
    loading.close();
    if (func) {
      func();
    }
  }
};